import {Col, Form, Radio, Row, Select, Tooltip, Typography} from "antd";
import React, {
  Fragment,
  Ref,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import residentialNurseService from "api/residentialNurse";
import {useAppDispatch} from "redux/hooks";
import {setIsChangetab, setListDoctor} from "redux/reducer/residentialNurse";
import {Notification} from "components/common";
import {employeeService} from "api";
import {surgeryStaff} from "./config";
import {toArray} from "helper/common";

export type PatientInfoRef = {
  getFormValue: () => any;
};

type Props = {
  infoPatient?: any;
  dataPersonalInfo?: any;
  ref?: Ref<PatientInfoRef>;
  id?: string | number;
};

const PersonalInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const {dataPersonalInfo, infoPatient} = props;
  const [surgeryStaff, setSurgeryStaff] = useState<any>([]);
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [valueRadio, setValueRadio] = useState(1);
  const [listBacSy, setListBacSy] = useState<any>();
  const [listDieuDuong, setListDieuDuong] = useState<any>();
  const [listAll, setListAll] = useState<any>();
  const getListNhanVien = async idPhongBan => {
    try {
      const listEmployeeData = await employeeService.searchEmployee({
        page: 1,
        limit: 50,
        idPhongBan: idPhongBan,
      });
      return listEmployeeData;
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lấy danh sách nhân viên");
    }
  };
  // const getAllNhanVien = async () => {
  //   try {
  //     const response = await Promise.all([
  //       getListNhanVien(27),
  //       getListNhanVien(24),
  //       getListNhanVien(26),
  //     ]);
  //     setListDieuDuong(toArray(response?.[0]?.items));
  //     setListBacSy([
  //       ...toArray(response?.[1]?.items),
  //       ...toArray(response?.[2]?.items),
  //     ]);

  //     setListAll([
  //       ...toArray(response?.[0]?.items),
  //       ...toArray(response?.[1]?.items),
  //       ...toArray(response?.[2]?.items),
  //     ]);
  //   } catch (error) {}
  // };
  // useEffect(() => {
  //   getAllNhanVien();
  // }, []);
  const getLitSurgeryStaff = async () => {
    try {
      const res = await residentialNurseService.getLitSurgeryStaff();
      setSurgeryStaff(res);
      console.log(res);
      dispatch(setListDoctor(res));
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách nhân sự phẫu thuật"
      );
    }
  };

  useEffect(() => {
    getLitSurgeryStaff();
  }, []);

  useEffect(() => {
    const parseBBhoiCHan = JSON.parse(
      JSON.parse(infoPatient?.bienBanHoiChan ?? null)
    );

    const parseredData =
      parseBBhoiCHan && parseBBhoiCHan[parseBBhoiCHan?.length - 1]?.data;

    if (parseredData) {
      form.setFieldValue(
        ["bacSiPhauThuat", "list"],
        dataPersonalInfo?.bacSiPhauThuat ?? [`${parseredData?.phauThuatVien}`]
      );
      form.setFieldValue(
        ["bacSiPhauThuat", "soLuongBacSi"],
        dataPersonalInfo?.soLuongBacSi ?? 1
      );
      setValueRadio(1);
    }
  }, [infoPatient]);

  useEffect(() => {
    if (dataPersonalInfo) {
      form.resetFields();
      form.setFieldsValue(dataPersonalInfo);
    } else form.resetFields();
  }, [dataPersonalInfo]);

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      const rawValues = form.getFieldsValue();

      return rawValues;
    },
  }));

  const handleChange = e => {
    if (e) {
      dispatch(setIsChangetab(true));
    }
  };

  return (
    <div className="personel-info">
      <Form form={form} onValuesChange={handleChange}>
        <Row gutter={[16, 8]}>
          {surgeryStaff.map(item => (
            <Fragment key={item.id}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item
                  name={[item.name, "soLuongBacSi"]}
                  label={
                    <Tooltip title={item.title} placement="top" arrow={false}>
                      <Typography.Text ellipsis={true}>
                        {item.title}
                      </Typography.Text>
                    </Tooltip>
                  }
                  labelAlign="left"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                >
                  <Radio.Group
                    defaultValue={0}
                    onChange={e => {
                      if (e.target.value === 0) {
                        form.setFieldValue([item.name, "list"], undefined);
                      }
                    }}
                  >
                    <Tooltip title={`Không được chọn ${item.title} nào`}>
                      <Radio value={0}>0</Radio>
                    </Tooltip>
                    <Tooltip title={`Được chọn tối đa 1 ${item.title}`}>
                      <Radio value={1}>1</Radio>
                    </Tooltip>
                    <Tooltip title={`Được chọn tối đa 2 ${item.title}`}>
                      <Radio value={2}>2</Radio>
                    </Tooltip>
                    <Tooltip title={`Được chọn tối đa 3 ${item.title}`}>
                      <Radio value={3}>3</Radio>
                    </Tooltip>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Form.Item name={[item.name, "list"]}>
                  <Select
                    mode="tags"
                    size={"large"}
                    style={{width: "100%"}}
                    options={
                      [
                        ...toArray(item?.list)?.map(e => ({
                          label: e?.name,
                          value: e?.name,
                        })),
                      ]
                      // item.name == "nhanVienKhac"
                      //   ? listAll?.map(e => ({
                      //       label: e?.hoTen,
                      //       value: e?.hoTen,
                      //     }))
                      //   : item.name == "bacSiPhauThuat" ||
                      //     item.name == "bacSiPhauThuatPhu" ||
                      //     item.name == "bacSiGayMe"
                      //   ? listBacSy?.map(e => ({
                      //       label: e?.hoTen,
                      //       value: e?.hoTen,
                      //     }))
                      //   : listDieuDuong?.map(e => ({
                      //       label: e?.hoTen,
                      //       value: e?.hoTen,
                      //     }))
                    }
                    onChange={e => {
                      const valueRadio = form.getFieldValue([
                        item.name,
                        "soLuongBacSi",
                      ]);
                      if (valueRadio !== undefined) {
                        form.setFieldsValue({
                          [item.name]: {
                            list: form
                              .getFieldValue([item.name, "list"])
                              .slice(0, valueRadio),
                          },
                        });
                      } else
                        form.setFieldsValue({
                          [item.name]: {
                            list: [],
                          },
                        });
                    }}
                    // filterOption={(input, option) => {
                    //   return option?.label
                    //     .toString()
                    //     .toLowerCase()
                    //     .includes(input.toLowerCase());
                    // }}
                    suffixIcon={
                      <Typography.Text className="select-suffix-label">
                        Danh sách
                      </Typography.Text>
                    }
                  />
                </Form.Item>
              </Col>
            </Fragment>
          ))}
        </Row>
      </Form>
    </div>
  );
});

export default PersonalInfo;
